angular.module('component.bulkActions')
  .component('bulkActionTitle', {
    template: '{{::$ctrl.name}}<span ng-if="$ctrl.fileName"> - {{::$ctrl.fileName}}</span>',
    bindings: {
      name: '<',
      fileName: '<'
    }
  });
